import request from '@/utils/request2'

// 列表(主数据列表)
export function loadSurveyQuestionnaireDetailExceptionListDataApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetailException/listByPage',
    method: 'post',
    data
  })
}

// 导出
export function exportSurveyQuestionnaireDetailExceptionListDataApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetailException/exportByPage',
    method: 'post',
    data
  })
}

// 查看
export function viewSurveyQuestionnaireDetailExceptionApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetailException/view',
    method: 'post',
    data
  })
}

// 待处理数量
export function countTodoSurveyQuestionnaireDetailExceptionApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetailException/countByTodo',
    method: 'post',
    data
  })
}

// 更新处理结果
export function updateProcessResultSurveyQuestionnaireDetailExceptionApi(data) {
  return request({
    url: 'tms-web/surveyQuestionnaireDetailException/updateProcessResult',
    method: 'post',
    data
  })
}
